module.exports = __webpack_public_path__ + "img/3.ff5790b2.png";